export const FETCH_LIST_PAYPAL_ACCOUNTS = "FETCH_LIST_PAYPAL_ACCOUNTS";
export const FETCH_SHOW_LOADING_PAGE = "FETCH_SHOW_LOADING_PAGE";
export const FETCH_DATA_SETTINGS = "FETCH_DATA_SETTINGS";
export const FETCH_DATA_STATISTICAL = "FETCH_DATA_STATISTICAL";
export const FETCH_DATA_LIST_STORE = "FETCH_DATA_LIST_STORE";
export const FETCH_FILTER = "FETCH_FILTER";
export const FECTH_PLAN_TABLE = "FECTH_PLAN_TABLE";
export const FECTH_MODAL_YEARLY_PLAN = "FECTH_MODAL_YEARLY_PLAN";
export const FECTH_MODAL_YEARLY_PLAN_ENHANCE =
  "FECTH_MODAL_YEARLY_PLAN_ENHANCE";
export const FETCH_MODAL_CHARGE = "FETCH_MODAL_CHARGE";

export const FETCH_YEAR_END_WRAP = "FETCH_YEAR_END_WRAP";
export const SET_YEAR_END_DATA = "SET_YEAR_END_DATA";
export const FETCH_HAS_YEAR_END = "FETCH_HAS_YEAR_END";
